import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { formatDate } from '../../../utils';

const WeddingCountdown = ({ weddingDate: propWeddingDate }) => {
  const [weddingDate] = useState(propWeddingDate || '2025-12-31');
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +new Date(weddingDate) - +new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [weddingDate]);

  const timeUnits = [
    { label: 'Days', value: timeLeft.days, color: 'bg-primary' },
    { label: 'Hours', value: timeLeft.hours, color: 'bg-secondary' },
    { label: 'Minutes', value: timeLeft.minutes, color: 'bg-accent' },
    { label: 'Seconds', value: timeLeft.seconds, color: 'bg-success' }
  ];

  return (
    <div className="bg-gradient-to-br from-primary via-primary-600 to-primary-700 rounded-xl p-4 md:p-6 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-2 md:top-4 right-2 md:right-4">
          <Icon name="Heart" size={80} className="text-white md:w-30 md:h-30" />
        </div>
        <div className="absolute bottom-2 md:bottom-4 left-2 md:left-4">
          <Icon name="Sparkles" size={60} className="text-white md:w-20 md:h-20" />
        </div>
      </div>

      <div className="relative z-10">
        <div className="text-center mb-4 md:mb-6">
          <h3 className="font-heading font-semibold text-xl md:text-2xl mb-2">
            Your Wedding Countdown
          </h3>
          <p className="text-white/90 text-base md:text-lg">
            {formatDate(weddingDate, 'long')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 md:gap-4 mb-4 md:mb-6">
          {timeUnits.map((unit, index) => (
            <div 
              key={unit.label}
              className="text-center"
            >
              <div className={`${unit.color} bg-white/20 backdrop-blur-sm rounded-lg md:rounded-xl p-2 md:p-4 mb-2`}>
                <div className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold font-heading">
                  {unit.value.toString().padStart(2, '0')}
                </div>
              </div>
              <div className="text-white/80 text-xs md:text-sm font-medium">
                {unit.label}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm rounded-full px-3 md:px-4 py-2">
            <Icon name="Calendar" size={16} className="text-white" />
            <span className="text-white/90 text-xs md:text-sm">
              {timeLeft.days > 0 ? `${timeLeft.days} days to go!` : 'Your big day is here!'}
            </span>
          </div>
        </div>

        {timeLeft.days <= 30 && timeLeft.days > 0 && (
          <div className="mt-4 bg-warning/20 backdrop-blur-sm rounded-lg p-3 border border-warning/30">
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={16} className="text-warning flex-shrink-0" />
              <span className="text-warning text-xs md:text-sm font-medium">
                Final preparations time! Less than 30 days to go.
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WeddingCountdown;